import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips, round } from '../Utility/utility.js';
import { Button } from 'react-bootstrap';
import { HenriChart } from './HenriChart';
import { ContractTable } from './ContractTable';

// import './PlayerCard.css';
import '../Pages/Players.css';
import latinize from 'latinize';

// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';

export class PlayerCardExpanded extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc:
        'https://tsnimages.tsn.ca/ImageProvider/PlayerHeadshot?seoId=&width=136&height=136',
      data: this.props.selectedPlayer.stats,
      selectedPlayerCap: [],
      selectedPlayerSurplus: [],
      selectedPlayerHenri: [],
      selectedPlayerSeasons: []
    };
  }
  componentDidMount() {
    let first = latinize(
      this.props.selectedPlayer.player_name
        .split(' ')[0]
        .toLowerCase()
        .replace('.', '')
        .replace('.', '')
    );
    let last = latinize(
      this.props.selectedPlayer.player_name.split(' ')[1].toLowerCase()
    );
    //console.log(first, last);
    let src =
      'https://tsnimages.tsn.ca/ImageProvider/PlayerHeadshot?seoId=' +
      first +
      '-' +
      last;
    if (src != this.state.imgSrc) {
      let capHit = [];
      let surplus = [];
      let henri = [];
      let seasons = [];
      for (var i = 0; i < this.props.selectedPlayer.contract_info.length; i++) {
        capHit.unshift(this.props.selectedPlayer.contract_info[i].cap_hit);
        surplus.unshift(this.props.selectedPlayer.contract_info[i].surplus);
        henri.unshift(this.props.selectedPlayer.contract_info[i].henri);
        seasons.unshift(this.props.selectedPlayer.contract_info[i].season);
      }
      console.log(capHit, surplus, henri, seasons);
      this.setState({
        imgSrc: src,
        selectedPlayerCap: capHit,
        selectedPlayerSurplus: surplus,
        selectedPlayerHenri: henri,
        selectedPlayerSeasons: seasons
      });
    }
  }

  render() {
    const { data } = this.state;
    var dict = this.props.dict;
    var arr = [];

    for (var key in dict) {
      arr.push(dict[key]);
    }
    return (
      <div
        className="players-player-card"
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <span
          className="previousButton"
          onClick={e => window.history.back()}
          style={{ width: '20%' }}
        >
          &#8678; Back to Previous Page
        </span>
        <div
          style={{
            borderRight: '1px solid #61696e',
            flex: 2,
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              margin: '1em'
            }}
          >
            <img
              class="players-bio-pic"
              src={this.state.imgSrc}
              alt="Smiley face"
              width="200"
              height="200"
            />
          </div>
          <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
            <strong style={{ fontSize: '24px', letterSpacing: '2.5px' }}>
              {this.props.selectedPlayer.player_name}
            </strong>
          </div>
          <div
            style={{
              textAlign: 'center',
              marginBottom: '1em',
              justifyContent: 'center'
            }}
          >
            <img
              src={
                'https://tsnimages.tsn.ca/ImageProvider/TeamLogo?seoId=' +
                this.props.selectedPlayer.team_name
                  .replace(' ', '-')
                  .replace(' ', '-')
                  .toLowerCase()
              }
              alt="team logo"
              width="40"
              height="40"
            />
            <strong
              style={{
                fontSize: '18px',
                marginLeft: '0.5em',
                letterSpacing: '2.5px'
              }}
            >
              {this.props.selectedPlayer.team_name}
            </strong>
          </div>
          <div className="players-bio">
            <div className="players-info">
              <ul className="players-first-stats">
                <li>{this.props.selectedPlayer.position}</li>
                <li>{this.props.selectedPlayer.height}</li>
                <li>{this.props.selectedPlayer.weight}</li>
                <li style={{ border: 'none' }}>
                  Age: {this.props.selectedPlayer.age}
                </li>
              </ul>
            </div>
            <div className="players-info">
              <ul
                className="players-second-stats"
                style={{
                  display: 'flex',
                  width: '80%',
                  justifyContent: 'space-around'
                }}
              >
                <li>
                  <strong>Born:</strong> {this.props.selectedPlayer.birthdate}
                </li>
                <li>
                  <strong>Birthplace:</strong>{' '}
                  {this.props.selectedPlayer.birthplace}
                </li>
                <li>
                  <strong>Draft: </strong>
                  {this.props.selectedPlayer.draft_year}
                  {this.props.selectedPlayer.draft_year != 'Undrafted' && (
                    <span> {this.props.selectedPlayer.drafted_by},</span>
                  )}
                  {this.props.selectedPlayer.draft_year != 'Undrafted' && (
                    <span>
                      {' '}
                      Round: {this.props.selectedPlayer.draft_round}, Overall:
                    </span>
                  )}
                  {this.props.selectedPlayer.draft_year != 'Undrafted' && (
                    <span> {this.props.selectedPlayer.draft_overall}</span>
                  )}
                </li>
                <li>
                  <strong>Shoots:</strong>{' '}
                  {this.props.selectedPlayer.handedness}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 3 }}>
          {this.props.selectedPlayer.position != 'G' && (
            <table
              className="table"
              id="stats"
              style={{ display: 'table', marginBottom: '4em' }}
            >
              <tbody>
                <tr>
                  <th colspan="9">STATS</th>
                </tr>
                <tr>
                  <th>Season</th>
                  <th>Team</th>
                  <th>GP</th>
                  <th>ATOI</th>
                  <th>G</th>
                  <th>A</th>
                  <th>P</th>
                  <th>SOG</th>
                  <th>CF%</th>
                </tr>
                {this.props.selectedPlayer.stats.map(
                  item =>
                    item.season_type == '02' && (
                      <tr>
                        <td>{item.season}</td>
                        <td>{item.team}</td>
                        <td>{item.games_played}</td>
                        <td>
                          {item.toi
                            ? (item.toi / item.games_played).toFixed(2)
                            : null}
                        </td>
                        <td>{item.goals}</td>
                        <td>{item.assists}</td>
                        <td>{item.points}</td>
                        <td>{item.shots}</td>
                        <td>{item.corsi_pct && item.corsi_pct.toFixed(2)}</td>
                      </tr>
                    )
                )}
              </tbody>
            </table>
          )}
          {this.props.selectedPlayer.position === 'G' && (
            <table
              className="table"
              id="stats"
              style={{ display: 'table', marginBottom: '4em' }}
            >
              <tbody>
                <tr>
                  <th colspan="7">STATS</th>
                </tr>
                <tr>
                  <th>Season</th>
                  <th>Team</th>
                  <th>GP</th>
                  <th>ATOI</th>
                  <th>SV %</th>
                  <th>GAA</th>
                  <th>CF%</th>
                </tr>
                {this.props.selectedPlayer.stats.map(
                  item =>
                    item.season_type == '02' && (
                      <tr>
                        <td>{item.season_year}</td>
                        <td>{item.team}</td>
                        <td>{item.games_played}</td>
                        <td>{item.atoi && item.atoi.toFixed(2)}</td>
                        <td>{item.sv_pct && item.sv_pct.toFixed(4)}</td>
                        <td>{item.gaa && item.gaa.toFixed(4)}</td>
                        <td>{item.cf_pct && item.cf_pct.toFixed(2)}</td>
                      </tr>
                    )
                )}
              </tbody>
            </table>
          )}
          <table
            className="table"
            id="salary"
            style={{ display: 'table', marginBottom: '4em' }}
          >
            <tbody>
              <tr>
                <th colspan="8">SALARY</th>
              </tr>
              <tr>
                <th>Season</th>
                <th>Cap Hit</th>
                <th>AAV</th>
                <th>HENRI</th>
                <th>Surplus</th>
                <th>Total Salary</th>
                <th>Status</th>
                <th>Years Left</th>
              </tr>
              {this.props.selectedPlayer.contract_info.map(
                item =>
                  (item.henri || item.cap_hit) && (
                    <tr>
                      <td>{item.season}</td>
                      <td>
                        {item.cap_hit && '$' + item.cap_hit.toLocaleString()}
                      </td>
                      <td>{item.aav && '$' + item.aav.toLocaleString()}</td>
                      <td>{item.henri && '$' + item.henri.toLocaleString()}</td>
                      <td>
                        {item.surplus && '$' + item.surplus.toLocaleString()}
                      </td>
                      <td>
                        {item.total_salary &&
                          '$' + item.total_salary.toLocaleString()}
                      </td>
                      <td>{item.expiry_status}</td>
                      <td>{item.years_remaining}</td>
                    </tr>
                  )
              )}
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '2em'
          }}
        >
          {this.props.selectedPlayer && (
            <HenriChart
              height={600}
              width={1000}
              selectedPlayer={this.props.selectedPlayer}
              cap={this.state.selectedPlayerCap}
              surplus={this.state.selectedPlayerSurplus}
              henri={this.state.selectedPlayerHenri}
              seasons={this.state.selectedPlayerSeasons}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/PlayerCardExpanded.js